module.exports = __webpack_public_path__ + "static/bedding-bedspreads-b395efebb3033964450318f55f13dc01.png";